import { BUSINESS_TIMEZONE, formatLkr } from "@mango-moons/domain";

export const money = (minor: number) => `LKR ${formatLkr(minor)}`;
export const amount = formatLkr;
export const cx = (...parts: (string | false | null | undefined)[]) => parts.filter(Boolean).join(" ");

const timeFormat = new Intl.DateTimeFormat("en-GB", { timeZone: BUSINESS_TIMEZONE, hour: "numeric", minute: "2-digit", hour12: true });
const dateTimeFormat = new Intl.DateTimeFormat("en-GB", { timeZone: BUSINESS_TIMEZONE, day: "2-digit", month: "short", hour: "numeric", minute: "2-digit", hour12: true });
const longDate = new Intl.DateTimeFormat("en-GB", { timeZone: BUSINESS_TIMEZONE, weekday: "long", day: "numeric", month: "long" });
export const time = (iso: string) => timeFormat.format(new Date(iso));
export const dateTime = (iso: string) => dateTimeFormat.format(new Date(iso));
export const longToday = () => longDate.format(new Date());
export const colomboHour = () => Number(new Intl.DateTimeFormat("en-GB", { timeZone: BUSINESS_TIMEZONE, hour: "2-digit", hourCycle: "h23" }).format(new Date()));

export function minutesAgo(iso: string, now = Date.now()): string {
  const minutes = Math.max(0, Math.floor((now - Date.parse(iso)) / 60_000));
  return minutes < 1 ? "Just now" : minutes < 60 ? `${minutes} min` : `${Math.floor(minutes / 60)}h ${minutes % 60}m`;
}
/** Stock quantities are stored in thousandths. */
export const qty = (milli: number) => (milli / 1000).toLocaleString("en-LK", { maximumFractionDigits: 3 });
export function parseQty(text: string): number | undefined {
  const match = /^(-?)(\d{1,9})(?:\.(\d{1,3}))?$/.exec(text.trim().replace(/,/g, ""));
  if (!match) return undefined;
  return (match[1] ? -1 : 1) * (Number(match[2]) * 1000 + Number((match[3] ?? "").padEnd(3, "0")));
}
export const minutesToTime = (minutes: number) => `${String(Math.floor(minutes / 60) % 24).padStart(2, "0")}:${String(minutes % 60).padStart(2, "0")}`;
export const timeToMinutes = (value: string) => { const [hours, minutes] = value.split(":").map(Number); return (hours ?? 0) * 60 + (minutes ?? 0); };

export function download(filename: string, content: string, type = "text/csv;charset=utf-8") {
  const url = URL.createObjectURL(new Blob([type.startsWith("text/csv") ? "﻿" : "", content], { type }));
  const link = Object.assign(document.createElement("a"), { href: url, download: filename });
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
